<template>
  <div>
<!--    <a-row  :gutter="[16,16]">-->
<!--      <a-col :xs="24" :sm="8" :md="8" :lg="8" :xl="6">-->
<!--        <div class="card profile">-->
<!--          <img class="avatar" src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fsafe-img.xhscdn.com%2Fbw1%2Fdfcd8b8e-a0a7-48f1-8473-a8f06b1b31e2%3FimageView2%2F2%2Fw%2F1080%2Fformat%2Fjpg&refer=http%3A%2F%2Fsafe-img.xhscdn.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1692353254&t=756bebc9df199c67c679fc1a2b255a3a"/>-->
<!--          <div class="profile-cnt">-->
<!--            <div class="nickname">樱桃小丸子</div>-->
<!--            <div class="phone">158******2075</div>-->
<!--          </div>-->
<!--          <a-icon type="swap" class="switch"/>-->
<!--        </div>-->
<!--      </a-col>-->
<!--      <a-col :xs="24" :sm="16" :md="16" :lg="16" :xl="18">-->
<!--        <div class="card datas">-->
<!--          <div class="header">-->
<!--            <div class="title">今日数据</div>-->
<!--            <div class="more">详细分析<a-icon type="right" /></div>-->
<!--          </div>-->
<!--          <div class="body">-->
<!--            <div v-for="i in 3" :key="'data_' + i" class="item">-->
<!--              <div class="value">0.00</div>-->
<!--              <div class="title">总销售额</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </a-col>-->
<!--    </a-row>-->

    <a-row  :gutter="[16,16]">
      <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="card profile">
          <img class="avatar" :src="userInfo ? userInfo.avatar : ''"/>
          <div class="profile-cnt">
            <div class="nickname">{{userInfo ? userInfo.nickname : ''}}</div>
            <div class="phone">{{userInfo ? userInfo.phone : ''}}</div>
          </div>
<!--          <a-icon type="swap" class="switch" />-->
        </div>
      </a-col>
    </a-row>


    <div class="card windows">
      <div class="header">
        <div style="display: flex;align-items: center;">
          <div class="tag"></div>
          我的橱窗
        </div>
<!--        <a-input-search placeholder="请输入商品信息查询" style="max-width: 200px" @search="onSearch" />-->
      </div>

      <a-tabs default-active-key="tikTok">
        <a-tab-pane key="tikTok" tab="抖音">
          <WindowView pvd="tikTok"/>
        </a-tab-pane>
        <a-tab-pane key="kuaishou" tab="快手">
          <WindowView pvd="kuaishou"/>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import WindowView from "@/pages/Setting/mine-window/window-view.vue";
import {createNamespacedHelpers} from 'vuex'
const {mapGetters} = createNamespacedHelpers('user')
export default {
  name: "mine-window",
  components: {
    WindowView
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({userInfo: 'getUserInfo'}),
  },
  mounted() {
  },
  methods: {
    onSearch() {

    },

  }
}
</script>

<style scoped lang="scss">
.card {
  background: #FFFFFF;
  box-shadow: 0px 0px 28px 0px rgba(217,217,217,0.19);
  border-radius: 13px;
  padding: 24px;
}

.profile {
  height: 125px;
  display: flex;
  align-items: center;
  position: relative;
  .avatar {
    flex-shrink: 0;
    width: 76px;
    height: 76px;
    margin-right: 8px;
    border-radius: 50px;
  }
  .profile-cnt {
    flex-grow: 1;
    overflow: hidden;
    .nickname {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
    .phone {
      margin-top: 4px;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
  }
  @media screen and (min-width: 576px) and (max-width: 760px) {
    .profile-cnt {
      display: none;
    }
  }

  .switch {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
    font-size: 12px;
    color: #333333;
  }
}

.datas {
  height: 125px;
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;

    .title {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
    .more {
      font-size: 14px;
      color: #B0B0B0;
      line-height: 20px;
    }
  }

  .body {
    display: flex;
    flex-grow: 1;

    .item {
      display: flex;
      flex: 1;
      flex-direction: column;
      margin-right: 8px;
      .value {
        font-size: 26px;
        font-weight: 500;
        color: #333333;
        line-height: 37px;
      }
      .title {
        font-size: 14px;
        font-weight: 500;
        color: #A6A6A6;
        line-height: 20px;
      }
    }
  }
}

.windows {
  margin-top: 12px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;

    .tag {
      width: 3px;
      height: 15px;
      background: #FA6400;
      margin-right: 4px;
    }

  }

  .goods {
    display: flex;

    .goods-img {
      width: 72px;
      height: 72px;
      border-radius: 8px;
      margin-right: 8px;
    }

    .goods-title {
      font-size: 14px;
      color: #000000;
      line-height: 30px;
    }

    .goods-price {
      font-size: 11px;
      font-weight: 500;
      color: #FF4242;
      line-height: 16px;
    }

    .goods-oprice {
      font-size: 11px;
      font-weight: 500;
      color: #C0C0C0;
      line-height: 16px;
      margin-left: 8px;
      text-decoration: line-through;
    }
  }
}
</style>
